import type { CartItem } from '../../../cart'

type Props = {
  title: string
  itemsLabel: string
  items: CartItem[]
  formatCurrency: (value: number) => string
}

const resolveImage = (item: CartItem) => item.productImageUrl || ''

export const CartSidebarSummary = ({ title, itemsLabel, items, formatCurrency }: Props) => (
  <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
    <div className="mb-3 border-b border-slate-100 pb-3">
      <h2 className="text-sm font-semibold uppercase tracking-[0.14em] text-slate-700">{title}</h2>
      <p className="mt-1 text-xs text-slate-500">{itemsLabel}</p>
    </div>
    <ul className="space-y-3">
      {items.map((item) => {
        const imageUrl = resolveImage(item)
        return (
          <li key={item.itemId} className="grid grid-cols-[56px_1fr] gap-3 rounded-xl border border-slate-100 p-2.5">
            {imageUrl ? (
              <img
                src={imageUrl}
                alt={item.productName}
                className="h-14 w-14 rounded-lg border border-slate-200 bg-slate-50 object-cover"
                loading="lazy"
              />
            ) : (
              <div className="grid h-14 w-14 place-items-center rounded-lg border border-slate-200 bg-slate-50 text-[10px] font-semibold uppercase tracking-[0.12em] text-slate-500">
                N/A
              </div>
            )}
            <div className="min-w-0">
              <p className="truncate text-sm font-semibold text-slate-900">{item.productName}</p>
              <div className="mt-1.5 flex items-center justify-between text-xs">
                <span className="text-slate-600">x{item.quantity}</span>
                <span className="font-semibold text-slate-800">{formatCurrency(item.lineTotal)}</span>
              </div>
            </div>
          </li>
        )
      })}
    </ul>
  </section>
)
